import { IDoneFunctions, ITranslatedField } from '../interfaces';
import { instances } from '../core/axios';
import { refreshWithRequest } from '../helpers/refresh-with-request';

export interface IPerpStatusPayload {
  name: ITranslatedField;
}

export const perpStatusesService = {
  async getOne(id: string, done?: IDoneFunctions) {
    try {
      return await instances.commonInstance.get(`perp-statuses/${id}`);
    } catch (e) {
      done?.failure();
    }
  },

  async createOne(payload: IPerpStatusPayload, done?: IDoneFunctions) {
    try {
      await instances.commonInstance.post('perp-statuses', payload);
      done?.success();
    } catch (e: any) {
      if (e.response.status === 401) {
        refreshWithRequest({
          onSuccess: (data) => {
            return instances.commonInstance
              .post(`perp-statuses`, payload, {
                headers: {
                  Authorization: `Bearer ${data.access_token}`,
                },
              })
              .then(() => {
                document.location.href = `${document.location.origin}/#/perp-statuses`;
              });
          },
        });
      }
      done?.failure();
    }
  },

  async updateOne(
    id: string,
    payload: IPerpStatusPayload,
    done?: IDoneFunctions,
  ) {
    try {
      await instances.commonInstance.patch(`perp-statuses/${id}`, payload);
      done?.success();
    } catch (e: any) {
      if (e.response.status === 401) {
        refreshWithRequest({
          onSuccess: (data) => {
            return instances.commonInstance
              .patch(`perp-statuses/${id}`, payload, {
                headers: {
                  Authorization: `Bearer ${data.access_token}`,
                },
              })
              .then(() => {
                document.location.href = `${document.location.origin}/#/perp-statuses`;
              });
          },
        });
      }
      done?.failure();
    }
  },
};
